import React from 'react';

import ClickableIcon from '~components/ClickableIcon';
import { faTrash } from '~components/icon';

import { Row } from './types';

interface ComponentProps {
  row: Row;
  onDelete: (row: Row) => void;
  tooltip?: string;
  disabled?: boolean | ((row: Row) => boolean);
}

const DeleteAction: React.FC<ComponentProps> = ({ row, onDelete, tooltip, disabled = false }) => (
  <div className="d-flex justify-content-center">
    <ClickableIcon
      id={`${row.id}-delete`}
      icon={faTrash}
      className="me-2"
      size="small"
      color="danger"
      onClick={() => onDelete(row)}
      disabled={typeof disabled === 'function' ? disabled(row) : disabled}
      toolTip={tooltip || 'Delete Row'}
    />
  </div>
);

export default DeleteAction;
